import styled from 'styled-components';

export const StatusTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: #494949;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
  gap: 16px;
  min-height: 36px;
`;

export const DateTitle = styled.span`
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.01em;
  color: #949494;
`;

export const TextField = styled.span`
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  color: #494949;
  padding: 4px 8px;
  min-height: 28px;
`;

export const DateWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 2px;
`;
